import {useEffect, useState} from "react";
import {useRestClient} from "../client/SpmRestClient";
import {Spinner} from "react-bootstrap";
import {EntityWithNameIdSelect} from "zavadil-react-common";
import {ContactTypeView} from "../types/ContactType";
import {useAlerts} from "../utils/UserAlerts";

export type SelectContactTypeProps = {
	sourceId?: string | null;
	selectedContactTypeId?: number | null;
	onChange(selectedContactTypeId?: number | null): any;
}

export default function SelectContactType({sourceId, selectedContactTypeId, onChange}: SelectContactTypeProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [contactTypes, setContactTypes] = useState<Array<ContactTypeView>>();

	useEffect(() => {
			if (sourceId) {
				restClient.contactTypes.bySource(sourceId)
					.then(setContactTypes)
					.catch((e) => userAlerts.err(e));
			} else {
				restClient.contactTypes.all()
					.then(setContactTypes)
					.catch((e) => userAlerts.err(e));
			}
		},
		[sourceId]
	);

	return contactTypes ? <EntityWithNameIdSelect
		options={contactTypes}
		id={selectedContactTypeId}
		onChange={onChange}
		showEmptyOption={true}
	/> : <Spinner/>
}
